import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { CategoryID } from '@sbt-web/network/types';
import { Button } from '@sbt-web/ui';
import { getCategoryThemeById } from '@/shared/helpers/Themes';
import styles from './index.module.scss';
interface ConfirmMessageProps {
  isVisible: boolean;
  categoryId: CategoryID;
  advertiserName: string;
  onClick: () => void;
  recommendedSearch?: boolean;
}
export const ConfirmMessage = t0 => {
  const $ = _c(18);
  const {
    isVisible,
    categoryId,
    advertiserName,
    onClick,
    recommendedSearch: t1
  } = t0;
  const recommendedSearch = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== categoryId) {
    t2 = getCategoryThemeById(categoryId);
    $[0] = categoryId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imagePath = `/static/img/ad-reply/thankyou-${t2}.svg`;
  let t3;
  if ($[2] !== isVisible) {
    t3 = classNames(styles.confirmMessage, {
      [styles.show]: isVisible
    });
    $[2] = isVisible;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== imagePath) {
    t4 = <img className={styles.image} src={imagePath} alt="" width="240" height="180" />;
    $[4] = imagePath;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="headline-6">Messaggio inviato</h2>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== advertiserName) {
    t7 = <p className="body-text">Troverai la conversazione con {advertiserName} {t6}nella sezione messaggi o nella tua casella di posta</p>;
    $[8] = advertiserName;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = recommendedSearch ? "Vedi annunci Rivenditori" : "Chiudi";
  let t9;
  if ($[10] !== onClick || $[11] !== t8) {
    t9 = <Button design="solid" onClick={onClick}>{t8}</Button>;
    $[10] = onClick;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t7 || $[16] !== t9) {
    t10 = <div className={t3}>{t4}{t5}{t7}{t9}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};